import { StyleSheet } from 'aphrodite'

import table from './table'
import status from './status'
import buttons from './buttons'
import tickets from './tickets'
import form from './form'
import headers from './headers'
import paragraphs from './paragraphs'
import search from './search'
import filter from './filter'
import filterbox from './filterbox'
import author from './author'
import selector from './selector'
import top from './top'

import ColorBlind from './ColorBlind'

export default {
  table: StyleSheet.create(table),
  tickets: StyleSheet.create(tickets),
  status: StyleSheet.create(status),
  buttons: StyleSheet.create(buttons),
  form: StyleSheet.create(form),
  headers: StyleSheet.create(headers),
  paragraphs: StyleSheet.create(paragraphs),
  search: StyleSheet.create(search),
  filter: StyleSheet.create(filter),
  filterbox: StyleSheet.create(filterbox),
  author: StyleSheet.create(author),
  selector: StyleSheet.create(selector),
  top: StyleSheet.create(top),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Support/style/index.js